"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _BusinessEntityTypeSelector = require("./BusinessEntityTypeSelector.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BusinessEntityTypeSelector = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(BusinessEntityTypeSelector, _React$PureComponent);

  var _super = _createSuper(BusinessEntityTypeSelector);

  function BusinessEntityTypeSelector(props) {
    var _this;

    _classCallCheck(this, BusinessEntityTypeSelector);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleEntityTypeSelection", function (entityType) {
      if (!entityType) {
        return;
      }

      _this.props.clickHandler(entityType);
    });

    _defineProperty(_assertThisInitialized(_this), "formatEntityTypes", function () {
      var entityTypes = _this.props.entityTypes;

      if (!entityTypes || !entityTypes.length) {
        return undefined;
      }

      var buttons = entityTypes.filter(function (type) {
        return !type.isLink;
      });
      var sortedButtons = buttons.sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      });
      return sortedButtons.map(function (buttonInfo) {
        return /*#__PURE__*/_react.default.createElement(_BusinessEntityTypeSelector.StyledButton, {
          dataTestId: "business-type-".concat(buttonInfo.id),
          key: "".concat(buttonInfo.label, "-").concat(buttonInfo.id),
          colorTheme: "primaryGhost",
          onClick: function onClick() {
            return _this.handleEntityTypeSelection(buttonInfo);
          },
          "data-type": buttonInfo.id
        }, buttonInfo.label);
      });
    });

    _this.buttons = _this.formatEntityTypes();
    return _this;
  }

  _createClass(BusinessEntityTypeSelector, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!(0, _lodash.isEqual)(prevProps, this.props)) {
        this.buttons = this.formatEntityTypes();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      return /*#__PURE__*/_react.default.createElement(_BusinessEntityTypeSelector.StyledButtonContainer, {
        className: className,
        "data-test-id": "business-entity-type-selector"
      }, this.buttons);
    }
  }]);

  return BusinessEntityTypeSelector;
}(_react.default.PureComponent);

_defineProperty(BusinessEntityTypeSelector, "propTypes", {
  /** Styling classname */
  className: _propTypes.default.string,

  /**
   * The array of entity types sent from the getEntityTypes call in SFDC
   *
   * Note: this component will filter out entities with the `isLink` attribute,
   * but you can also filter these out before passing the entity types to the
   * component ... obviously.
  */
  entityTypes: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    displayName: _propTypes.default.string,
    isLink: _propTypes.default.bool,
    sortOrder: _propTypes.default.number
  })).isRequired,

  /** Emits actions needed to progress to next page */
  clickHandler: _propTypes.default.func.isRequired
});

_defineProperty(BusinessEntityTypeSelector, "defaultProps", {
  className: ''
});

var _default = BusinessEntityTypeSelector;
exports.default = _default;